import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	shareTriggerButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	shareTriggerButtonText: {
		id: 'share-button.share-trigger-button-text',
		defaultMessage: 'Share',
		description: 'Default text for the disabled share dialog trigger button',
	},
});
